// extracted by mini-css-extract-plugin
export default {"title":"pilih-tanggal-transaksi-properti_title__VoOgW","error-message":"pilih-tanggal-transaksi-properti_error-message__ZN4eG"};